<script lang="ts"></script>

<h2 class="text-headline-line">
    Registration Closed
</h2>

<p>
    Registration is currently closed. Follow our socials to know when we open it again!
</p>